// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_Up","border":"e_Vp"};